import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import ApiContext from './contexts/apiContext';
import UserContext from './contexts/userContext';
import { getAuthUser, getUserSettings } from './api';
import UserRoleCheck from './components/UserRoleCheck';
import Admin from './components/Admin';
import ChatUI from './components/ChatUI';
import LoggedOut from './components/LoggedOut';
import DataSources from './components/DataSources';
import localeCodeToLocale from './helpers/localeCodeToLocale';
import { ADMIN_ROLE } from './constants';
var App = function (_a) {
    var apiBaseUrl = _a.apiBaseUrl;
    var prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)');
    var _b = useState(), user = _b[0], setUser = _b[1];
    var _c = useState(), userSettings = _c[0], setUserSettings = _c[1];
    var _d = useState(createTheme({ palette: { mode: prefersDarkMode ? 'dark' : 'light' } })), theme = _d[0], setTheme = _d[1];
    var isLoggedOut = window.location.pathname === '/logged-out';
    useEffect(function () {
        if (isLoggedOut) {
            return;
        }
        Promise.allSettled([getAuthUser(apiBaseUrl), getUserSettings(apiBaseUrl)])
            .then(function (_a) {
            var userResult = _a[0], userSettingsResult = _a[1];
            if (userResult.status === 'rejected') {
                return window.location.assign("".concat(apiBaseUrl, "/auth"));
            }
            setUser(userResult.value);
            setUserSettings(userSettingsResult.status === 'fulfilled' ? userSettingsResult.value : undefined);
        })
            .catch(function (err) {
            // eslint-disable-next-line no-console
            console.error(err);
        });
    }, []);
    useEffect(function () {
        var themeDarkMode = theme.palette.mode === 'dark';
        if (typeof (userSettings === null || userSettings === void 0 ? void 0 : userSettings.darkMode) !== 'undefined' && userSettings.darkMode !== themeDarkMode) {
            setTheme(createTheme({ palette: { mode: userSettings.darkMode ? 'dark' : 'light' } }));
        }
    }, [userSettings, theme]);
    if (!user && !isLoggedOut) {
        return _jsx(_Fragment, {});
    }
    return (_jsx(DndProvider, { backend: HTML5Backend, children: _jsxs(ThemeProvider, { theme: theme, children: [_jsx(CssBaseline, {}), _jsx(LocalizationProvider, { dateAdapter: AdapterDateFns, adapterLocale: localeCodeToLocale(userSettings === null || userSettings === void 0 ? void 0 : userSettings.locale), children: _jsx(ApiContext.Provider, { value: { apiBaseUrl: apiBaseUrl }, children: _jsx(UserContext.Provider, { value: { setUserSettings: setUserSettings, user: user, userSettings: userSettings }, children: _jsx(BrowserRouter, { children: _jsxs(Routes, { children: [_jsx(Route, { path: "/", element: _jsx(ChatUI, {}) }), _jsx(Route, { path: "/datasources", element: _jsx(DataSources, {}) }), _jsx(Route, { path: "/admin", element: _jsx(UserRoleCheck, { roles: [ADMIN_ROLE], showError: true, children: _jsx(Admin, {}) }) }), _jsx(Route, { path: "/logged-out", element: _jsx(LoggedOut, {}) })] }) }) }) }) })] }) }));
};
export default App;
